import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";

import ContactPage from "./pages/ContactPage/ContactPage";

import Login from "./pages/Login/Login";
import SignUp from "./pages/SignUp/SignUp";
import MainLayout from "Layout/MainLayout/MainLayout";
import AuthenticationLayout from "Layout/AuthenticationLayout/AuthenticationLayout";
import ForgotPassword from "pages/ForgotPassword/ForgotPassword";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route path="" element={<Home />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>{" "}
        <Route path="/" element={<AuthenticationLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="sign-up" element={<SignUp />} />{" "}
          <Route path="forgot-password" element={<ForgotPassword />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
